import { Link } from "react-router-dom";

export default function Logo({ compact = false }) {
  return (
    <Link to="/" data-testid="site-logo" className="flex items-center group">
      <img
        src="/logo.png"
        alt="AI Scale Force Store"
        className={`${compact ? "h-11" : "h-14 sm:h-16"} w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
      />
    </Link>
  );
}
